import styled from 'styled-components';

export const HomeSliderSection = styled.section`
  position: relative;
  overflow: hidden;
  height: calc(100vh - 50px);

  @media (min-width: 1100px) {
    max-height: calc(100vh - 50px);
  }

  @media (max-width: 1099px) {
    max-height: calc(570px);
    margin-top: 115px;
  }

  @media (max-width: 991.98px) {
    max-height: calc(432px);
  }

  @media (max-width: 767.98px) {
    max-height: calc(324px);
  }

  @media (max-width: 575.98px) {
    max-height: calc(207px);
  }

  .slick-next,
  .slick-prev {
    height: 30px;
    width: 30px;
    z-index: 90;

    @media (max-width: 848px) {
      display: none !important;
    }

    &:before {
      border: solid #ffffff;
      border-width: 0 4px 4px 0;
    }
  }

  .slick-prev {
    left: 80px;
  }

  .slick-next {
    right: 80px;
  }

  .slick-slider {
    width: 100%;
    margin: 0 auto;
    max-width: initial;
    color: #fff;
    padding: 0;
    position: relative;
  }

  .slick-slider,
  .slick-slide,
  .slick-list,
  .slick-track {
    height: 100%;
  }

  iframe {
    pointer-events: none;
    border: none;
  }

  &[dir='rtl'] {
    p {
      letter-spacing: 0px;
      font-size: 18px;
      font-family: GESSTwoDWTCLight;
      line-height: 28px;
    }
  }
`;

export const HomeSlider = styled.div`
  overflow: hidden;
  padding: 0;
  margin: 0;
  width: 100%;
  position: relative;
  backface-visibility: hidden;
  z-index: 1;
  display: flex !important;
  min-height: 100%;
  background-image: url(/svg/loader.svg);
  background-repeat: no-repeat;
  background-position: center;

  &[dir='rtl'] {
    & > div:first-child {
      direction: ltr;
    }
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1;
  }

  @media (max-width: 1199px) {
    height: auto;
  }
`;

export const HomeSliderContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0 auto;
  transform: translate(-50%, -50%);
  padding-left: 105px;
  width: 780px;
  z-index: 10;

  h2 {
    font-size: 50px;
    line-height: 60px;
    margin: 0;

    .hline {
      &:before {
        width: 200px;
      }
    }

    a {
      color: #fff;
      text-decoration: underline;
    }
  }

  p {
    color: #fff;
    margin: 2rem 0 0;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 1.29px;

    @media (max-width: 1199.98px) {
      display: none;
    }
  }

  .link-wrapper {
    display: block;
    padding-top: 2rem;
    color: #fff;
    text-transform: uppercase;
    @media (max-width: 991.98px) {
      display: none;
    }
    a {
      color: #fff;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }
  &[dir='ltr'] {
    h2 {
      .hline {
        &:before {
          margin-left: -100px;
        }
      }
      @media (max-width: 767.98px) {
        span {
          padding-right: 5px;
        }
      }
    }
    .link-wrapper {
      a {
        font-size: 12px;
      }
    }
  }

  &[dir='rtl'] {
    h2 {
      .hline {
        &:before {
          margin-right: -100px;
        }
      }
      @media (max-width: 767.98px) {
        display: flex;
        flex-wrap: wrap;
        span {
          padding-left: 5px;
        }
      }
    }
    .link-wrapper {
      a {
        font-size: 14px;
        font-family: 'GESSTwoDWTCMedium';
      }
    }
  }

  @media (max-width: 1199px) {
    padding-left: 75px;
    width: auto;

    h2 {
      font-size: 40px;
      line-height: 50px;
    }
  }

  @media (max-width: 991px) {
    h2 {
      width: 500px;
    }
  }

  @media (max-width: 767px) {
    width: 70%;
    padding-left: 0;

    h2 {
      width: auto;
      font-size: 30px;
      line-height: 40px;

      span {
        display: inline;

        &.hline {
          &:before {
            content: none;
          }
        }
      }
    }
  }

  @media (max-width: 575px) {
    top: 50%;
    left: 25px;
    width: ${({ dir }) => (dir === 'rtl' ? '85%' : '80%')};
    transform: translate(0, -50%);

    h2 {
      font-size: 18px;
      line-height: 30px;
    }
  }

  @media (max-width: 350px) {
    left: 15px;
    width: ${({ dir }) => (dir === 'rtl' ? '85%' : '80%')};
  }
`;
